import React from 'react';

import {authorizationObject} from '@modules/client/components/ApiKey/components/Table/authorizationObject';
import {Authorization} from '@appComponents/Authorization';
import {renderActionsColumn} from '@modules/client/components/ApiKey/utils/helpers';

export const ApiKeyRowRenderer = (column, row, {clientId}) => {
    switch (column) {
        case 'id':
        case 'api_key':
        case 'description':
        case 'creation_datetime':
            return row[column];
        case 'environment':
        case 'creation_user':
            return row[column] ? row[column].name : null;
        case 'actions' :
            return (
                <Authorization authorization={authorizationObject}>
                    {renderActionsColumn(row, clientId)}
                </Authorization>
            );
        default:
            return null;
    }
};
